import { Address } from "./Address.js";
import { CartBreakdown } from "./CartBreakdown.js";
import { v4 as uuid } from 'uuid';
export var InvoiceType;
(function (InvoiceType) {
    InvoiceType["regular"] = "regular";
    InvoiceType["simplified"] = "simplified";
})(InvoiceType || (InvoiceType = {}));
export class InvoiceParty {
    name = null;
    address = null;
    vatId = null;
    constructor(data) {
        if (data) {
            let definedKeys = Object.keys(this);
            for (let key in data) {
                let value = data[key];
                let keyIsDefinedOnInstance = definedKeys.includes(key);
                if (keyIsDefinedOnInstance) {
                    if (value) {
                        //replace all firebase dates with real dates
                        if (value.seconds && value.toDate) {
                            value = value.toDate();
                        }
                        if (key == 'address') {
                            value = new Address(value);
                        }
                    }
                    Object.assign(this, { [key]: value });
                }
            }
        }
    }
}
/**
 * Helper class just to simplify firebase data handling
 * id == invoiceid
 */
export class InvoiceInfo {
    id;
    invoiceNumber = null;
    constructor(id, data) {
        this.id = id || uuid();
        if (data) {
            let definedKeys = Object.keys(this).filter((key) => key != "id");
            for (let key in data) {
                let value = data[key];
                let keyIsDefinedOnInstance = definedKeys.includes(key);
                if (keyIsDefinedOnInstance) {
                    if (value) {
                        //replace all firebase dates with real dates
                        if (value.seconds && value.toDate) {
                            value = value.toDate();
                        }
                    }
                    Object.assign(this, { [key]: value });
                }
            }
        }
    }
}
export class Invoice {
    id;
    previousInvoiceId = null;
    invoiceNumber = null;
    invoiceDate = null;
    hash = null;
    orderId = null;
    companyId = null;
    costBreakdown = null;
    dateIssued = null;
    issuer = null;
    receiver = null;
    taxRecordId = null;
    currency = null;
    type = InvoiceType.regular;
    isCorrection = false;
    correctedInvoiceId = null;
    constructor(id, data) {
        this.id = id || uuid();
        if (data) {
            let definedKeys = Object.keys(this).filter((key) => key != "id");
            for (let key in data) {
                let value = data[key];
                let keyIsDefinedOnInstance = definedKeys.includes(key);
                if (keyIsDefinedOnInstance) {
                    if (value) {
                        //replace all firebase dates with real dates
                        if (value.seconds && value.toDate) {
                            value = value.toDate();
                        }
                        if (key == 'issuer') {
                            value = new InvoiceParty(value);
                        }
                        if (key == 'receiver') {
                            value = new InvoiceParty(value);
                        }
                        if (key == 'costBreakdown') {
                            value = new CartBreakdown(value);
                        }
                    }
                    Object.assign(this, { [key]: value });
                }
            }
        }
    }
}
